import { relayStylePagination } from "@apollo/client/utilities";
import { TypedTypePolicies } from "../../generated/apollo-helpers";

// tslint:disable-next-line: no-unsafe-any
const replace = (_existing: any, incoming: any) => incoming;

export const typePolicies: TypedTypePolicies = {
  Query: {
    fields: {
      contentFeed: relayStylePagination(["filters"]),
      commentsForContent: relayStylePagination(),
      savedPushNotifications: relayStylePagination(),
      trendingContentFeed: relayStylePagination(),
      newsContentFeed: relayStylePagination(),
      upcomingEventsContentFeed: relayStylePagination(),
      vendors: relayStylePagination(),
      dealVendors: relayStylePagination(),
      curatedFeed: relayStylePagination(["uuid"]),
      visitorAppointments: relayStylePagination(["beginDate"]),
      visitorReceptionsAvailable: { merge: false },
      reqMgt: relayStylePagination(),
    },
  },
  Occurrence: {
    fields: {
      eventPost: { merge: true },
    },
  },
  User: {
    fields: {
      currentDestination: { merge: true },
    },
  },
  VendorCategory: {
    fields: {
      vendorList: relayStylePagination(),
    },
  },
  Profile: {
    fields: {
      cards: { merge: replace },
      siteProfiles: { merge: replace },
    },
  },
  CartSuccess: {
    merge: replace,
  },
  Order: {
    merge: replace,
  },
  EventPost: {
    fields: {
      featuredImage: { merge: true },
    },
  },
  ProductAvailability: { merge: true },
  /**
   * This is a client-only supertype for use with Apollo Client's `InMemoryCache` configuration. It
   * does not represent a real type in the GraphQL schema.
   *
   * This is an alternative way of specifying the keyFields used to generate the cache keys for all types with a
   * uuid field. This used to be achieved by providing a (now deprecated) `dataIdFromObject` function to the
   * InMemoryCache, however, doing this enables the canonizeResults option which can potentially cause memory
   * leaks, and has therefore been deprecated.
   *
   * See the generated/uuid-possible-types.ts file that is generated by a local codegen plugin to define
   * the TypeWithUuidKey supertype.
   */
  TypeWithUuidKey: {
    keyFields: ["uuid"],
  },
};
